import React from "react";
import styles from "./styles/CardStyle.module.css";
import classNames from "classnames";
import { startCase } from "lodash";
import { getPublicImageURL } from "../_helpers/image";
import { getTime } from "../_helpers/app/dt";
import {
    ClockCircleOutlined,
    DownOutlined,
    UpOutlined,
} from "@ant-design/icons";
import log from "cslog";
import { Spin, theme } from "antd";
import dayjs from "dayjs";
import VideoPlayOverlay from "./VideoPlayOverlay";

export const PLATFORM_IMG_MAPPING = {
    facebook_post: "facebook",
    facebook_story: "facebook",
    instagram_post: "instagram",
    instagram_story: "instagram",
    instagram_reel: "instagram",
    x_post: "twitter",
    youtube: "youtube",
    linkedin_post: "linkedin",
    medium: "medium",
    blog_post: "medium",
    x: "twitter",
    festival: "festival",
};

export const PLATFORM_IMG_MAPPING_NEW = {
    FACEBOOK_STORY: "facebook",
    FACEBOOK_POST: "facebook",
    INSTAGRAM_STORY: "instagram",
    INSTAGRAM_POST: "instagram",
    INSTAGRAM_REEL: "instagram",
    X_POST: "twitter",
    YOUTUBE: "youtube",
    LINKEDIN_POST: "linkedin",
    MEDIUM: "medium",
    BLOG_POST: "medium",
};

export const CalendarCard = ({
    item,
    onClick,
    loading = false,
    isMobile,
    compactStatus,
}) => {
    // log.d(item, "item in SMC");

    // normalize platforms into an array of platform keys
    const getPlatformsArray = () => {
        // if platforms is an array but empty, fall back to legacy item.platform (if present)
        if (Array.isArray(item.platforms)) {
            if (item.platforms.length === 0 && item.platform) {
                return [{ qdb_content_type_id: item.platform }];
            }
            return item.platforms;
        }
        if (item.platforms) return [item.platforms];
        // fallback: legacy `item.platform` string
        if (item.platform) return [{ qdb_content_type_id: item.platform }];
        return [];
    };

    const platforms = getPlatformsArray();
    const contentType =
        item.content_type ||
        (platforms[0]
            ? platforms[0].post_type?.toLowerCase() ||
              platforms[0].qdb_content_type_id ||
              platforms[0].qdb_content_type ||
              platforms[0]
            : "");

    return (
        <div
            className={classNames(styles.calendarCard, {
                [styles.mobileCard]: isMobile,
            })}
            onClick={onClick}
        >
            {!isMobile ? (
                // Desktop layout - vertical
                <>
                    {item.type === "festival" && (
                        <div className={styles.socialStatusWrapper}>
                            <SocialStatus
                                key="festival"
                                data={{
                                    post_type: "festival",
                                    status: "FESTIVAL",
                                }}
                                compactStatus={compactStatus}
                            />
                        </div>
                    )}
                    {item.type !== "festival" && (
                        <div className={styles.socialStatusWrapper}>
                            {platforms.length > 0 &&
                                platforms.map((plt, idx) => (
                                    <SocialStatus
                                        key={idx}
                                        data={plt}
                                        compactStatus={compactStatus}
                                    />
                                ))}
                        </div>
                    )}
                    {item.img_url && (
                        <div
                            className={styles.imgContainer}
                            style={{ position: "relative" }}
                        >
                            <img
                                src={item.img_url}
                                alt={
                                    item.content
                                        ? item.content.slice(0, 100)
                                        : ""
                                }
                                className={styles.img}
                            />
                            {item.media_type === "video" && (
                                <VideoPlayOverlay size="large" />
                            )}
                        </div>
                    )}

                    {item.img && (
                        <div
                            className={styles.imgContainer}
                            style={{ position: "relative" }}
                        >
                            <img
                                src={getPublicImageURL(item.img)}
                                alt={
                                    item.content
                                        ? item.content.slice(0, 100)
                                        : ""
                                }
                                className={styles.img}
                            />
                            {item.media_type === "video" && (
                                <VideoPlayOverlay size="large" />
                            )}
                        </div>
                    )}
                    <div className={styles.content}>{item.content}</div>

                    {/* <div className={styles.cardFooter}>

                        <div className={styles.tags}>
                            {item.tags?.map((tag, index) => (
                                <div key={index} className={styles.tag}>
                                    {startCase(tag)}
                                </div>
                            ))}
                        </div>

                        <div className={styles.tags}>
                            {platforms?.length > 0 && platforms.map(plt => <TimeTag
                                // time={getTime(plt?.posting_time, "t")}
                                time={dayjs(plt?.posting_time).format("HH:mm")}
                                // status={plt?.post_status} />)}
                                status={getNormalizedStatus(plt?.posting_time, plt?.post_status)} />)}
                        </div>
                    </div> */}
                </>
            ) : (
                // Mobile layout - horizontal
                <div className={styles.mobileLayout}>
                    <div
                        className={classNames(styles.mobileTextSection, {
                            [styles.mobileTextSectionNoImage]: !item.img,
                        })}
                    >
                        <div className={styles.mobileCardHeader}>
                            {/* multiple platform icons for mobile */}
                            <div
                                style={{
                                    display: "flex",
                                    gap: 6,
                                    alignItems: "center",
                                }}
                            >
                                {platforms.length > 0 ? (
                                    platforms.map((p, idx) => {
                                        const key =
                                            p?.post_type?.toLowerCase() ||
                                            p?.qdb_content_type_id ||
                                            p?.qdb_content_type ||
                                            p;
                                        const imgName =
                                            PLATFORM_IMG_MAPPING[key] ||
                                            "medium";
                                        return (
                                            <img
                                                key={idx}
                                                src={`/images_rte/icons/${imgName}.png`}
                                                alt={imgName}
                                                className={
                                                    styles.mobilePlatformIcon
                                                }
                                            />
                                        );
                                    })
                                ) : (
                                    <img
                                        src={`/images_rte/icons/medium.png`}
                                        alt="medium"
                                        className={styles.mobilePlatformIcon}
                                    />
                                )}
                            </div>

                            <div className={styles.mobileContentType}>
                                {startCase(contentType || "")}
                            </div>
                        </div>

                        <div
                            className={classNames(
                                !item.img
                                    ? styles.mobileContentExpanded
                                    : styles.mobileContent
                            )}
                        >
                            {item.content}
                        </div>
                        <div className={styles.tags}>
                            {item.tags?.map((tag, index) => (
                                <div key={index} className={styles.mobileTag}>
                                    {startCase(tag)}
                                </div>
                            ))}
                        </div>
                    </div>
                    {(item.img || item.img_url) && (
                        <div
                            className={styles.mobileImageSection}
                            style={{ position: "relative" }}
                        >
                            <img
                                src={
                                    item.img_url
                                        ? item.img_url
                                        : getPublicImageURL(item.img)
                                }
                                alt={
                                    item.content
                                        ? item.content.slice(0, 100)
                                        : ""
                                }
                                className={styles.mobileImg}
                            />
                            {item.media_type === "video" && (
                                <VideoPlayOverlay size="small" />
                            )}
                        </div>
                    )}
                </div>
            )}

            {loading && (
                <div className={styles.overlay}>
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default CalendarCard;

function useStatusColors() {
    const { token } = theme.useToken();
    return {
        Idea: { bg: token.colorFillQuaternary, text: token.colorTextSecondary },
        Draft: {
            bg: token.colorFillQuaternary,
            text: token.colorTextSecondary,
        },
        "In Review": { bg: token.colorWarningBg, text: token.colorWarningText },
        Approved: { bg: token.colorSuccessBg, text: token.colorSuccessText },
        ApprovedO: { bg: token.colorSuccessBg, text: token.colorSuccessText },
        Scheduled: { bg: token.colorSuccessBg, text: token.colorSuccessText },
        Failed: { bg: token.colorErrorBg, text: token.colorErrorText },
        Cancelled: { bg: token.colorErrorBg, text: token.colorErrorText },
        Posted: { bg: token.colorInfoBg, text: token.colorInfoText },
        Festival: { bg: token.colorInfoBg, text: token.colorInfoText },
        NA: { bg: token.colorFillTertiary, text: token.colorTextTertiary },
    };
}

const MEDIA_TYPES = {
    instagram_post: "Post",
    instagram_story: "Story",
    instagram_reel: "Reel",
    facebook_post: "Post",
    facebook_story: "Story",
    linkedin_post: "Post",
    linkedin_story: "Story",
};

const STATUS_MAPPING = {
    IDEA: "Idea",
    DRAFT: "Draft",
    IDLE: "In Review",
    APPROVED: "ApprovedO", // ready to render
    READY_TO_PUBLISH: "Approved",
    PUBLISHING: "Scheduled",
    PUBLISHED: "Posted",
    PUBLISH_FAILED: "Failed",
    FAILED: "Failed",
    CANCELLED: "Cancelled",
    FESTIVAL: "Festival",
};

function SocialStatus({ data, compactStatus }) {
    const key = data?.post_type?.toLowerCase() || data?.qdb_content_type_id;
    const imgName = PLATFORM_IMG_MAPPING[key] || key;

    // const status = getNormalizedStatus(data.scheduled_time || data.posting_time, data.status?.toLowerCase() || data.post_status?.toLowerCase())
    // const status = STATUS_MAPPING[data.status] || data.status;
    const status = STATUS_MAPPING[data.status] || "NA";

    return (
        <div className={styles.socialStatusItem}>
            <div className={styles.platformContainer}>
                <img
                    src={`/images_rte/icons/${imgName}.png`}
                    alt={imgName}
                    className={styles.platformIcon}
                />
                <span>{MEDIA_TYPES[key]}</span>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "5px",
                    // justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {(data?.scheduled_time || data?.posting_time) && (
                    <span className={styles.timing}>
                        {/* <ClockCircleOutlined />{" "} */}
                        {dayjs(
                            data?.scheduled_time || data?.posting_time
                        ).format("HH:mm")}
                    </span>
                )}
                <StatusIndicator
                    status={status}
                    compact={compactStatus}
                    text={compactStatus ? "" : startCase(status)}
                />
            </div>
        </div>
    );
}

function StatusIndicator({ status, compact, text }) {
    const statusColors = useStatusColors();
    const { token } = theme.useToken();
    const colors = statusColors[status] ?? {
        bg: token.colorFillTertiary,
        text: token.colorTextTertiary,
    };

    if (compact) {
        return (
            <span
                style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: colors.bg,
                    border: `1px solid ${token.colorBorder}`,
                    display: "inline-block",
                }}
            />
        );
    }

    return (
        <span
            style={{
                color: colors.text,
                backgroundColor: colors.bg,
                padding: "2px 6px",
                borderRadius: "8px",
                lineHeight: "1.2",
            }}
        >
            {text}
        </span>
    );
}

function getNormalizedStatus(time, status) {
    const now = new Date();
    const postingTime = new Date(time);
    if (
        postingTime < now &&
        ["approved", "scheduled", "pending"].includes(status)
    ) {
        return "draft";
    }
    return status;
}
